import { Component, Input, inject } from '@angular/core';
import { CurrencyPipe, DatePipe, Location, PercentPipe } from '@angular/common';
import { RightBridgeApiService } from '../../../services/right-bridge-api.service';
import { SessionStorageService } from '../../../services/session-storage.service';
import { WarnDialogComponent } from '../../../warn-dialog/warn-dialog.component';
import { ClipboardService } from 'ngx-clipboard';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxLoadingModule } from 'ngx-loading';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-multi-table-card',
  templateUrl: './multi-table-card.component.html',
  styleUrls: ['./multi-table-card.component.scss'],
  imports: [
    NgxLoadingModule,
    MatIconModule,
    MatButtonModule,
    PercentPipe,
    DatePipe,
    CurrencyPipe,
    MatTooltipModule,
  ],
})
export class MultiTableCardComponent {
  private location = inject(Location);
  private rbs = inject(RightBridgeApiService);
  private ss = inject(SessionStorageService);
  dialog = inject(MatDialog);
  private clippy = inject(ClipboardService);
  private snacky = inject(MatSnackBar);

  @Input() title;
  @Input() infoKey;
  @Input() tradeDetail;
  @Input() linkedAccount;
  @Input() sourceDataButton;
  loading = false;

  emptyCellCheck(infoPoint) {
    if (infoPoint.varName === 'TaxBracketSource') {
      if (this.tradeDetail.Details[infoPoint.varSet][infoPoint.varName]) {
        return false;
      } else if (this.tradeDetail.Details[infoPoint.varSet]['TaxBracket']) {
        return false;
      }
      return true;
    }

    if (
      infoPoint.varSet &&
      this.tradeDetail.Details[infoPoint.varSet] &&
      this.tradeDetail.Details[infoPoint.varSet][infoPoint.varName]
    ) {
      return false;
    }

    if (
      infoPoint.varSet &&
      this.tradeDetail.Details[infoPoint.varSet] &&
      !this.tradeDetail.Details[infoPoint.varSet][infoPoint.varName]
    ) {
      return true;
    }

    if (this.tradeDetail[infoPoint.varName]) {
      return false;
    }

    return true;
  }

  viewSourceData() {
    window.open(
      `${this.location.prepareExternalUrl(
        `/trade-source-data/${this.tradeDetail.TradeID}`
      )}`,
      '_blank'
    );
  }

  decryptValue(value: string, title: string) {
    this.loading = true;
    this.rbs.decryptValue(value).subscribe({
      next: resp => {
        this.loading = false;
        if (resp['resultString']) {
          let dialogRef = this.dialog.open(WarnDialogComponent, {
            panelClass: 'warn-dialog',
            data: {
              headline: title,
              content: `Value: ${resp['resultString']}`,
              confirm: 'Copy to Clipboard',
              cancel: 'Close',
              hideCancel: false,
            },
          });
          dialogRef.afterClosed().subscribe(result => {
            if (result === 'continue') {
              this.clippy.copy(resp['resultString']);
              this.snacky.open(`Copied to clipboard!`, 'Close', {
                duration: 4000,
              });
            }
            dialogRef = null;
          });
        }
      },
      error: err => {
        this.loading = false;
        console.error('ERROR: ', err);
        this.snacky.open(
          `Oops! Something went wrong. Please try again.`,
          'Close',
          {
            duration: 4000,
          }
        );
      },
    });
  }

  checkConditional(infoPoint) {
    if (!infoPoint.conditional) {
      return true;
    } else if (
      infoPoint.conditional &&
      infoPoint.label === 'Linked Direct Account'
    ) {
      return infoPoint.conditional(this.linkedAccount);
    } else if (infoPoint.conditional) {
      return infoPoint.conditional();
    }
    return false;
  }

  showRowLink(infoPoint) {
    const rights = this.ss.get('rights');
    if (
      infoPoint.label === 'Linked Direct Account' &&
      !rights.includes('AccountLinking')
    ) {
      return false;
    }
    return true;
  }

  navigate(infoPoint) {
    if (infoPoint.label === 'Linked Direct Account') {
      window.open(
        `${this.location.prepareExternalUrl(
          `/${infoPoint.rowLink}/${this.tradeDetail.Details.Trade.AccountID}`
        )}`,
        '_blank'
      );
    }
  }
}
